
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zh from './locales/zh.json'
import ru from './locales/ru.json'
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'zh',  // 默认语言
  fallbackLocale: ['en', 'ru'], // 备用语言
  messages: {
    en,
    zh,
    ru
  }
})

export default i18n
